import type { CSSObject } from '@emotion/react'
import { Color, Theme, Typography } from '@opallabs/gem'

export const placeholderText = (theme: Theme): CSSObject => ({
  ...Typography.T500,
  color: Color[theme].Text.Gray,
  opacity: '50%',
})
